import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getTerminalMasterApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getTerminalMaster = createAsyncThunk('getTerminalMaster', async (payload) => {
  return await getTerminalMasterApi(payload);
});

const getTerminalMasterSlice = createSlice({
  name: 'getTerminalMaster', // Unique Name
  initialState,
  reducers: {
    getTerminalMasterReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTerminalMaster.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getTerminalMaster.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getTerminalMaster.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getTerminalMasterReset } = getTerminalMasterSlice.actions;

export default getTerminalMasterSlice.reducer;
